import React from "react";
import { Box, Container } from "@mui/system";
import { Grid, Skeleton, Typography } from "@mui/material";

export default function Layout1Section1({ acf, ...props }) {
  console.log(acf);
  console.log(props.logo);

  return (
    <Box
      sx={{
        position: "relative",
        background: "#FFF",
        pt: 4,
        pb: 10,
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#fff",
          transform: "translateZ(1px)",
        }}
      >
        {props?.logo && props.logo !== "" && (
          <img
            src={props.logo}
            alt="logo"
            style={{ width: "140px", marginLeft: "auto" }}
            id={"header-logo"}
          />
        )}

        <Grid container alignItems="center" spacing={4}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: {
                  xs: "100%",
                },
              }}
            >
              {acf?.title && acf?.title !== "" ? (
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: "3rem",
                    fontWeight: 600,
                    mb: "1rem",
                    color: "#000",
                    // borderBottom: "1px solid #000",
                    // paddingBottom: "1rem",
                  }}
                  dangerouslySetInnerHTML={{ __html: acf.title }}
                />
              ) : (
                <Skeleton
                  sx={{
                    maxWidth: "300px",
                  }}
                />
              )}

              {acf?.description && acf?.description !== "" ? (
                <Typography
                  variant="p"
                  component="p"
                  sx={{
                    color: "#000",
                  }}
                  dangerouslySetInnerHTML={{ __html: acf.description }}
                />
              ) : (
                <Skeleton
                  sx={{
                    maxWidth: "300px",
                  }}
                />
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: {
                  xs: "100%",
                },
              }}
            >
              <img
                src={acf?.featured_image?.url}
                alt={acf?.featured_image?.alt}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
